"use client"

import { IS_PRODUCTION_ENV } from "@src/utils/environment"
import Script from "next/script"

/**
 * GA4 loader. Strips URL hash fragments from page_location on every gtag
 * call. On sensitive routes the parent layout passes `suppress={true}` and
 * we render nothing, so gtag/js is never fetched — no Referer leak possible.
 * `useAnalyticsOptOut` handles SPA navigation into sensitive routes via the
 * ga-disable-* flag.
 */
export function SafeGoogleAnalytics({
  gaId,
  suppress,
}: {
  gaId: string
  suppress: boolean
}) {
  if (!IS_PRODUCTION_ENV || suppress) return null

  return (
    <>
      <Script id="_next-ga-init">
        {`
          window.dataLayer = window.dataLayer || [];
          function __gtag(){window.dataLayer.push(arguments);}
          window.gtag = function() {
            var args = [].slice.call(arguments);
            if (args[0] === 'config' || args[0] === 'event') {
              args[2] = Object.assign({}, args[2], {
                page_location: window.location.href.split('#')[0]
              });
            }
            __gtag.apply(null, args);
          };
          // SYNC: localStorage key must match usePrivateModeStore persist name
          (function() {
            try {
              var raw = localStorage.getItem('app_private_mode');
              var priv = raw ? JSON.parse(raw) : null;
              if (priv && priv.state && priv.state.isPrivateModeEnabled) {
                window['ga-disable-${gaId}'] = true;
              }
            } catch (e) {}
          })();
          window.gtag('js', new Date());
          window.gtag('config', '${gaId}');
        `}
      </Script>
      <Script
        id="_next-ga"
        src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
      />
    </>
  )
}
